import { Users, Film, Infinity as InfinityIcon } from "lucide-react";
import { Reveal, SectionTag, CountUp } from "@/components/Reveal";

const ROLES = ["Lead Editors", "Motion Designers", "Colorists", "Sound Engineers", "Storyboard Artists", "Producers"];

export default function Studio() {
  return (
    <section id="studio" className="py-24 md:py-32 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6">
          <SectionTag>The Studio</SectionTag>
          <h2 className="font-display font-extrabold text-gray-900 text-3xl md:text-5xl tracking-tight mt-4 leading-[1.05]">
            A CREW BUILT
            <br />
            TO <span className="text-crimson">SCALE.</span>
          </h2>
          <p className="text-gray-500 text-base leading-relaxed mt-6 max-w-lg">
            From a tight 11-person edit floor to a full 50-strong production unit — Vertex assembles the exact
            team your project needs, then scales it the moment you need more.
          </p>
          <div className="flex flex-wrap gap-2.5 mt-8">
            {ROLES.map((r) => (
              <span
                key={r}
                className="px-4 py-2 rounded-full border border-gray-200 bg-white text-xs font-medium text-gray-600 shadow-soft hover:border-crimson/40 hover:text-gray-900 transition-colors duration-300"
              >
                {r}
              </span>
            ))}
          </div>
        </div>

        <div className="lg:col-span-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Reveal className="sm:col-span-2">
            <div className="card-hover h-full rounded-3xl border border-gray-100 bg-white shadow-soft p-8" data-testid="stat-team">
              <Users className="w-6 h-6 text-crimson" />
              <div className="font-display font-extrabold text-gray-900 text-5xl md:text-6xl mt-6 tracking-tight">
                <CountUp to={11} />–<CountUp to={50} />
              </div>
              <p className="text-gray-500 text-sm mt-3">Editors & production specialists in-house</p>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <div className="card-hover h-full rounded-3xl border border-gray-100 bg-white shadow-soft p-8" data-testid="stat-partners">
              <Film className="w-6 h-6 text-gold" />
              <div className="font-display font-extrabold text-gray-900 text-5xl md:text-6xl mt-6 tracking-tight">
                <CountUp to={5} />
              </div>
              <p className="text-gray-500 text-sm mt-3">Signature channel partners</p>
            </div>
          </Reveal>
          <Reveal delay={0.16} className="sm:col-span-3">
            <div
              className="rounded-3xl bg-crimson p-8 flex flex-col sm:flex-row sm:items-center gap-6 shadow-[0_24px_60px_rgba(255,42,59,0.3)]"
              data-testid="stat-any"
            >
              <InfinityIcon className="w-6 h-6 text-white shrink-0" />
              <div>
                <div className="font-display font-extrabold text-gray-900 text-xl sm:text-2xl md:text-3xl tracking-tight whitespace-nowrap">ANY × ANY × ANY</div>
                <p className="text-white/80 text-sm mt-1.5">Any type. Any quality. Any budget. One studio standard.</p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
